module.exports = __webpack_public_path__ + "img/gift-vulcans.4e6521f.png";